import * as React from 'react';
import AppContent from './AppContent';

import './App.scss';

class App extends React.Component {

  public render() {
    return <AppContent />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/Layout/AppLayout.tsx